// using for portal CITY
export const georesourceConstants = {
  GET_CITIES_REQUEST: 'GET_CITIES_REQUEST',
  GET_CITIES_SUCCESS: 'GET_CITIES_SUCCESS',
  GET_CITIES_FAILURE: 'GET_CITIES_FAILURE',

  GET_COUNTRIES_REQUEST: 'GET_COUNTRIES_REQUEST',
  GET_COUNTRIES_SUCCESS: 'GET_COUNTRIES_SUCCESS',
  GET_COUNTRIES_FAILURE: 'GET_COUNTRIES_FAILURE',

  GET_CURRENCIES_REQUEST: 'GET_CURRENCIES_REQUEST',
  GET_CURRENCIES_SUCCESS: 'GET_CURRENCIES_SUCCESS',
  GET_CURRENCIES_FAILURE: 'GET_CURRENCIES_FAILURE',

  GET_COUNTRIES_DIAL_CODES_REQUEST: 'GET_COUNTRIES_DIAL_CODES_REQUEST',
  GET_COUNTRIES_DIAL_CODES_SUCCESS: 'GET_COUNTRIES_DIAL_CODES_SUCCESS',
  GET_COUNTRIES_DIAL_CODES_FAILURE: 'GET_COUNTRIES_DIAL_CODES_FAILURE',
};
